import { Box, Button, Typography } from '@mui/material';
import { mismatchDataColumns } from '../table/DashboardData';
import { Tables } from '@/component/pools/table/Tables';
import { ResMismatchDataType, ResReadSwapCurrentType, ResReadSwapCurrentType2 } from '@/types';
import { packBigNumbers } from '@/lib/BigNumbers';

export default function MismatchData({ datas }: { datas: ResMismatchDataType[] }) {
  const list: ResMismatchDataType[] = datas.map((data) => ({
    address: data.address,
    total_amount: packBigNumbers(data.total_amount),
    ledger_amount: packBigNumbers(data.ledger_amount),
    difference: packBigNumbers(data.difference),
    result: data.result,
  }));

  return (
    <Box sx={{ mb: 3, px: 2, width: '100%' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        정합성 불일치 데이터
      </Typography>

      <Box sx={{ width: '100%' }}>
        {list && <Tables list={list} columns={mismatchDataColumns} getRowId={(row) => row.address} />}
      </Box>
    </Box>
  );
}
